// extracted by mini-css-extract-plugin
export var divider = "_wc-0";